import { TextRule } from '../rules'

export default function createTokenizer(rawRules) {
  if (!rawRules.length) {
    throw new Error('createTokenizer: please pass at least one rule')
  }

  const rules = rawRules.map((RuleClass, index) => {
    let pattern = RuleClass.pattern

    // Backward compatibility for legacy API
    if (typeof RuleClass.getRule === 'function') {
      const rule = RuleClass.getRule()
      pattern = rule.match
    }

    if (!(RuleClass.prototype instanceof TextRule)) {
      throw new Error('createTokenizer: all rules must extend TextRule')
    }
    if (index === 0 && pattern) {
      throw new Error('createTokenizer: first rule must be without pattern')
    }
    if (index > 0 && !pattern) {
      throw new Error('createTokenizer: all rules except first must have a pattern')
    }
    return {
      pattern: pattern ? new RegExp(`(${pattern.source})`) : null,
      createToken: (input) => new RuleClass(input),
    }
  })

  function tokenize(res, input, index) {
    const rule = rules[index]

    if (index === 0) {
      res.push(rule.createToken(input))
      return
    }

    const nextIndex = index - 1
    const splitted = input.split(rule.pattern)

    for (let i = 0; i < splitted.length; i++) {
      const item = splitted[i]

      if (i % 2 !== 0) {
        res.push(rule.createToken(item))
        continue
      }

      if (item.length === 0) {
        continue
      }

      tokenize(res, item, nextIndex)
    }
  }

  return function (input) {
    const res = []
    if (typeof input !== 'string') {
      return res
    }
    tokenize(res, input, rules.length - 1)
    return res
  }
}
